import React, { useEffect } from 'react';

import {
    useHistory
} from "react-router-dom";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    paperWrapper: {
        maxWidth: 1024,
        margin: '10px auto',
        '& p': {
            marginBottom: theme.spacing(2)
        },
    },
    table: {
        width: '100%',
        '& td, & th': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        '& tbody tr': {
            borderBottomColor: theme.palette.divider,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            '&:last-child': {
                borderBottom: 'none'
            },
        }
    },
    bordered: {
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    card: {
        backgroundColor: theme.palette.grey[100],
        '& .MuiCardContent-root': {
            padding: theme.spacing(1),
        }
    }
}));


const CoupleBalance = (props) => {
    const { id, balance, officiant } = props;

    const securityAnswer = officiant ? `${officiant.first_name} ${officiant.last_name}`: '';

    const classes = useStyles();

    let history = useHistory();

    const [data, setData] = React.useState([]);

    useEffect(() => {
        document.title = 'Couple Balance - Enduring Promises';

        new Promise((resolve, reject) => {
            let url = `/api/couples/${id}/balance`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .catch(reason => {
                    alert('An error prevented retrieving balances. Please refresh the page and try again.');
                })
        })
    }, [id]);

    const handleBackClick = () => {
        history.push('/couple')
    };

    const formatNumber = (number) => {
        return (number !== '' && number !== undefined) ? parseFloat(number).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        }) : '';
    }

    let subTotal = 0;

    return (
        <div className={classes.paperWrapper}>
            <Paper square className={classes.paper}>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" color="textPrimary" gutterBottom={true}>
                            Invoices and Payments
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Card square className={classes.card}>
                            <CardContent>
                                <table className={classes.table}>
                                    <thead>
                                        <tr className={classes.bordered}>
                                            <th>ID</th>
                                            <th>Type</th>
                                            <th>Date</th>
                                            <th className="text-center">Invoice</th>
                                            <th className="text-center">Payment</th>
                                            <th className="text-center">Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 && data.map(row => {
                                            subTotal = row.type == 'Payment' ? subTotal - parseFloat(row.payment) : subTotal + parseFloat(row.invoice);
                                            return (
                                                <tr key={`${row.type[0]}-${row.id}`}>
                                                    <td>{row.id.padStart(5, '0')}</td>
                                                    <td>{row.type}</td>
                                                    <td>{row.date}</td>
                                                    <td className="text-center">{formatNumber(row.invoice)}</td>
                                                    <td className="text-center">{formatNumber(row.payment)}</td>
                                                    <td className="text-center">{formatNumber(subTotal)}</td>
                                                </tr>
                                            )
                                        })}
                                        {!data.length > 0 && (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                   <Typography variant="body2" component="span" color="textSecondary">No invoices or payments yet</Typography>
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="text-center"></td>
                                            <td className="text-center"></td>
                                            <td className="text-center">{formatNumber(balance)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        {officiant &&
                            <Typography variant="body2">
                                If you are forwarding your Fee Balance by e-transfer, please email it to <a href="mailto:info@enduringpromises.com">info@enduringpromises.com</a>.
                                We ask that you add in the notes/comments the full name of your Officiant: <b>{securityAnswer}</b>.
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </Paper>
            <Box mt={2}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleBackClick}
                    endIcon={<Icon>chevron_right</Icon>}
                >
                        View Ceremony
                </Button>
            </Box>
        </div>
    )
}

export default CoupleBalance;
